import React, { Component } from "react";
import {
    Divider,
    Row,
    Col,
} from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import GenericOnClickModal from "../../../buttons/genericOnClickModal";
import AccountDetails from "./accountDetails";

class RecipientDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

    render() {
        return (
            <GenericOnClickModal
                size="md"
                button={
                    <>
                        View details <ArrowRightOutlined />
                    </>
                }
                modalTitle={`${
                    this.props.isInvestor ? "Investor" : "Recipient"
                } ACH/Wire Details`}
                modalBody={
                    <>
                        <h4>Account Holder</h4>
                        <Divider style={{ marginTop: "5px" }} />

                        <Row gutter={16}>
                            <Col span={12} style={{ textAlign: "left" }}>
                                {`${
                                    this.props.isInvestor
                                        ? "Investor"
                                        : "Recipient"
                                }/Beneficiary Name`}
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                <p>
                                    {
                                        this.props.recipientDetails
                                            .retrieved_values.name
                                    }
                                </p>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12} style={{ textAlign: "left" }}>
                                Email
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                <p>
                                    {
                                        this.props.recipientDetails
                                            .retrieved_values.email
                                    }
                                </p>
                            </Col>
                        </Row>

                    <h4>Account Details</h4>
                    <Divider style={{ marginTop: "5px" }} />
                    <AccountDetails recipientId={this.props.recipientDetails.id } />

                        <Row gutter={16}>
                            <Col span={12} style={{ textAlign: "left" }}>
                                Address
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                <p>
                                    <>
                                        {" "}
                                        {
                                            this.props.recipientDetails.address
                                                .street_line_1
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails.address
                                                .street_line_2
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails.address
                                                .city
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails.address
                                                .state
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails.address
                                                .zip_code
                                        }{" "}
                                    </>
                                </p>
                            </Col>
                        </Row>

                        <h4>Bank Details</h4>
                        <Divider style={{ marginTop: "5px" }} />
                        <Row gutter={16}>
                            <Col span={12} style={{ textAlign: "left" }}>
                                Bank Name
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                <p>
                                    {this.props.recipientDetails.retrieved_values.bank?.name}
                                </p>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12} style={{ textAlign: "left" }}>
                                Bank Address
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                <p>
                                    <>
                                        {" "}
                                        {
                                            this.props.recipientDetails
                                                .bank_address.street_line_1
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails
                                                .bank_address.street_line_2
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails
                                                .bank_address.city
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails
                                                .bank_address.state
                                        }
                                        {", "}
                                        {
                                            this.props.recipientDetails
                                                .bank_address.zip_code
                                        }{" "}
                                    </>
                                </p>
                            </Col>
                        </Row>
                    </>
                }
            />
        );
    }
}

export default RecipientDetailsModal;
